export default __webpack_public_path__ + "static/preview_300x620_VP9-c1bedf6141bddd16c4e7ffea1e888a89.webm";